module.exports = __webpack_public_path__ + "img/8.68b1486c.jpg";